export class BrowserUtils {
	public static isBrowser(): boolean {
		return typeof window !== "undefined";
	}

	public static isAppleMobile() {
		try {
			if (!window?.navigator?.userAgent) {
				return false;
			}
			//navigator won't be available in SSR. try catch
			return (
				["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
					window.navigator.platform
				) ||
				// iPad on iOS 13 detection
				(window.navigator.userAgent.includes("Mac") && "ontouchend" in document)
			);
		} catch (e) {
			return false;
		}
	}

	public static getOrigin() {
		return window.location.origin;
	}
}
